/**
 * Снять первый кадр MP4 в Mini App (fallback, если poster_url с API ещё нет).
 * Blob URL → canvas без CORS на внешний хост.
 */
export function extractVideoPosterFrame(videoSrc: string): Promise<string | undefined> {
  return new Promise((resolve) => {
    const src = videoSrc.trim();
    if (!src) {
      resolve(undefined);
      return;
    }

    let blobUrl: string | undefined;
    let settled = false;
    const finish = (value: string | undefined) => {
      if (settled) return;
      settled = true;
      if (blobUrl) URL.revokeObjectURL(blobUrl);
      resolve(value);
    };

    const captureFromVideo = (v: HTMLVideoElement) => {
      if (v.videoWidth < 2) return false;
      try {
        const canvas = document.createElement('canvas');
        canvas.width = v.videoWidth;
        canvas.height = v.videoHeight;
        const ctx = canvas.getContext('2d');
        if (!ctx) return false;
        ctx.drawImage(v, 0, 0);
        finish(canvas.toDataURL('image/jpeg', 0.85));
        return true;
      } catch {
        return false;
      }
    };

    const armVideo = (objectUrl: string) => {
      const v = document.createElement('video');
      v.muted = true;
      v.playsInline = true;
      v.preload = 'auto';
      v.setAttribute('playsinline', '');
      v.src = objectUrl;

      const onSeeked = () => {
        if (!captureFromVideo(v)) finish(undefined);
      };
      const onLoadedData = () => {
        try {
          v.currentTime = 0.05;
        } catch {
          captureFromVideo(v);
        }
      };
      const onError = () => finish(undefined);

      v.addEventListener('seeked', onSeeked, { once: true });
      v.addEventListener('loadeddata', onLoadedData, { once: true });
      v.addEventListener('error', onError, { once: true });
      v.load();
    };

    void (async () => {
      try {
        const res = await fetch(src, { mode: 'cors', credentials: 'omit' });
        if (!res.ok) {
          armVideo(src);
          return;
        }
        const blob = await res.blob();
        blobUrl = URL.createObjectURL(blob);
        armVideo(blobUrl);
      } catch {
        armVideo(src);
      }
    })();

    window.setTimeout(() => finish(undefined), 18_000);
  });
}
